export const TEACHERS_RESULTS = "TEACHERS_RESULTS";
